var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cus_login_wrapper login"},[_c('div',{staticClass:"login_box"},[_c('ul',{staticClass:"con"},[_c('li',{staticClass:"mart"},[_vm._v("廣告媒體合作")]),_c('li',[_vm._v("Email: marketing@hermesgames.com.tw")]),_c('li',{staticClass:"mart"},[_vm._v("客服信箱")]),_c('li',[_vm._v("Email: service@hermesgames.com.tw")])])])])
}]

export { render, staticRenderFns }